import axios from "axios";

const baseUrl = "https://api.sandbox.cp.clearsense.com/compellon/";

const fetchJobInfo = params => axios.get(`${baseUrl}job_info`, { params });

const fetchJobStatus = params => axios.get(`${baseUrl}status`, { params });

const fetchJobResult = params => axios.get(`${baseUrl}result`, { params });

const fetchJobList = params => axios.get(`${baseUrl}job_list`, { params });

const fetchJobResultOutput = params =>
  axios.get(`${baseUrl}result_output`, { params });

const fetchSubJobs = params => axios.get(`${baseUrl}sub_job_list`, { params });

const createBinaryModel = payload =>
  axios.post(`${baseUrl}build_binary_model`, payload);

const createWhatIfAnalysis = payload =>
  axios.post(`${baseUrl}what_if`, payload);

const createPrediction = payload =>
  axios.post(`${baseUrl}predict_binary_model`, payload);

const CompellonApi = {
  fetchJobInfo,
  fetchJobStatus,
  fetchJobResult,
  fetchJobResultOutput,
  fetchJobList,
  createBinaryModel,
  createWhatIfAnalysis,
  fetchSubJobs,
  createPrediction,
};

export default CompellonApi;
